import { getMandatoryEnvVar } from './env';

export const toggleNewLogin = (mode: string): boolean =>
    getMandatoryEnvVar('REACT_APP_NEW_AUTH') === 'true' && mode === 'customer';
